module.exports = __webpack_public_path__ + "static/media/uiLogoSymbolColor.bfdf0325.svg";